import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const itemStatusCellStyleId = 'item-status-cell-theme';

export const itemStatusCellBridgeStyles = {
  'item-status-cell-renderer': {
    '--local-status-cell-lock': tokens.color.foreground.quaternary,
    '--local-status-cell-lock-gap': tokens.spacing.xs,
    '--local-status-cell-lock-font-size': tokens.font.size.textSm,
  },
};
